// Gerado por scripts/migrate-html.mjs — não editar manualmente
export const PAGE_MANIFEST = [
  {
    "type": "html",
    "slug": "politica-de-privacidade-innova-crm-whatsapp",
    "title": "(in)nova now CRM - Política de Privacidade (Extensão WhatsApp)",
    "description": "Política de privacidade da extensão (in)nova now CRM para sincronização do WhatsApp Web com o CRM.",
    "contentKey": "privacy/politica-de-privacidade-innova-crm-whatsapp"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-innova-os",
    "title": "(in)nova os - Política de Privacidade",
    "description": "A (in)nova now é especializada no desenvolvimento de aplicativos e sistemas personalizados. Conheça a política de privacidade do app (in)nova os.",
    "contentKey": "privacy/politica-de-privacidade-innova-os"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-innova-holerites",
    "title": "(in)nova now",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "privacy/politica-de-privacidade-innova-holerites"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-innova-patio",
    "title": "(in)nova pátio - Política de Privacidade",
    "description": "A (in)nova now é especializada no desenvolvimento de aplicativos e sistemas personalizados. Conheça a política de privacidade do app (in)nova pátio.",
    "contentKey": "privacy/politica-de-privacidade-innova-patio"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-innova-lean5s",
    "title": "(in)nova now",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "privacy/politica-de-privacidade-innova-lean5s"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-innovapdf",
    "title": "(in)nova now",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "privacy/politica-de-privacidade-innovapdf"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-instituto-inova",
    "title": "(in)nova now",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "privacy/politica-de-privacidade-instituto-inova"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-app-escola-sp-rs",
    "title": "(in)nova now",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "privacy/politica-de-privacidade-app-escola-sp-rs"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-plusfitsports",
    "title": "(in)nova now",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "privacy/politica-de-privacidade-plusfitsports"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-agromak-pecas-agricolas",
    "title": "Agromak Vendas - Política de Privacidade",
    "description": "Política de privacidade do app Vendas Agromak - aplicativo exclusivo da empresa Agromak para gestão de vendas e orçamentos. Dados fornecidos pela Agromak.",
    "contentKey": "privacy/politica-de-privacidade-agromak-pecas-agricolas"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-demac-pecas-agricolas",
    "title": "Demac Vendas - Política de Privacidade",
    "description": "Política de privacidade do app Vendas Demac - aplicativo exclusivo da empresa Demac para gestão de vendas e orçamentos. Dados fornecidos pela Demac.",
    "contentKey": "privacy/politica-de-privacidade-demac-pecas-agricolas"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-mcl-pecas-agricolas-vendas",
    "title": "MCL Vendas - Política de Privacidade",
    "description": "Política de privacidade do app Vendas MCL - aplicativo exclusivo da empresa MCL para gestão de vendas e orçamentos. Dados fornecidos pela MCL.",
    "contentKey": "privacy/politica-de-privacidade-mcl-pecas-agricolas-vendas"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-ditrator",
    "title": "Vendas DITRATOR - Política de Privacidade",
    "description": "Política de privacidade do app Vendas DITRATOR - aplicativo exclusivo da empresa DITRATOR para gestão de vendas e orçamentos. Dados fornecidos pela DITRATOR.",
    "contentKey": "privacy/politica-de-privacidade-ditrator"
  },
  {
    "type": "html",
    "slug": "politica-de-privacidade-onsailing ",
    "title": "Onsailing - Política de Privacidade",
    "description": "Política de privacidade da plataforma Onsailing - Gestão náutica inteligente com IA, mapa e rede social.",
    "contentKey": "privacy/politica-de-privacidade-onsailing "
  },
  {
    "type": "react",
    "slug": "app-para-representante-comercial",
    "title": "App para Representante Comercial",
    "description": "App para representante comercial personalizado com catálogo, pedidos em campo, check-in de visitas, modo offline e integração com ERP."
  },
  {
    "type": "react",
    "slug": "innova-lean-5s",
    "title": "(in)nova lean 5S — App de Auditoria 5S",
    "description": "App de auditoria 5S para digitalizar o programa Lean: modelos personalizáveis, fotos de evidência e relatórios PDF."
  },
  {
    "type": "react",
    "slug": "innova-os",
    "title": "(in)nova OS — App de Ordem de Serviço",
    "description": "App de ordem de serviço para equipes de campo: atribuição, fotos, assinatura digital, materiais e PDF."
  },
  {
    "type": "react",
    "slug": "innova-crm",
    "title": "(in)nova now CRM — Funil, ERP e WhatsApp",
    "description": "CRM integrado a qualquer ERP personalizado, à Força de Vendas e ao WhatsApp Web. Organize conversas com a extensão oficial."
  },
  {
    "type": "html",
    "slug": "app-vendas-personalizado",
    "title": "Aplicativo de Vendas Pernonalizado",
    "description": "A innova now desenvolve aplicativos de vendas personalizados conforme as regras do seu negócio integramos com seu ERP.",
    "contentKey": "products/app-vendas-personalizado"
  },
  {
    "type": "html",
    "slug": "automatize-lancamento-de-frete",
    "title": "Automação de Lançamento de Fretes",
    "description": "Precisa automatizar o processso de lançamentos de notas de frete CTE, temos a solução.",
    "contentKey": "products/automatize-lancamento-de-frete"
  },
  {
    "type": "html",
    "slug": "cmms-app-de-manutencao-preventiva",
    "title": "App CMMS Personalizado - Manutenção Preventiva",
    "description": "Precisa de um aplicativo de Manutenção Preventiva CMMS, desenvolvemos conforme o sua regra de negócio, integramos ao seu ERP.",
    "contentKey": "products/cmms-app-de-manutencao-preventiva"
  },
  {
    "type": "html",
    "slug": "criamos-seu-app",
    "title": "Criamos Aplicativos Personalizados",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "products/criamos-seu-app"
  },
  {
    "type": "html",
    "slug": "forca-de-vendas-com-ia",
    "title": "Força de Vendas com IA",
    "description": "Precisa de um força de vendas personalizado é na innovanow Sistemas",
    "contentKey": "products/forca-de-vendas-com-ia"
  },
  {
    "type": "html",
    "slug": "forca-de-vendas-com-inteligencia-artificial",
    "title": "Força de Vendas com Inteligência Artificial",
    "description": "Precisa de um força de vendas personalizado é na innovanow Sistemas",
    "contentKey": "products/forca-de-vendas-com-inteligencia-artificial"
  },
  {
    "type": "html",
    "slug": "instituto-inova-seguranca",
    "title": "(in)nova now",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "products/instituto-inova-seguranca"
  },
  {
    "type": "html",
    "slug": "plataforma-web-jovem-aprendiz",
    "title": "Plataforma para Jovem Aprendiz",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "products/plataforma-web-jovem-aprendiz"
  },
  {
    "type": "html",
    "slug": "documentacao-vendas-innova",
    "title": "(in)nova now",
    "description": "A (in)nova now innova now é especializada no desenvolvimento de aplicativos e sistemas personalizados para empresas, como integração com ERPs e soluções de automação.",
    "contentKey": "products/documentacao-vendas-innova"
  },
  {
    "type": "delete-account",
    "slug": "excluir-conta-innova-os",
    "id": "innova-os"
  },
  {
    "type": "delete-account",
    "slug": "excluir-conta-innova-holerites",
    "id": "innova-holerites"
  },
  {
    "type": "delete-account",
    "slug": "excluir-conta-innova-patio",
    "id": "innova-patio"
  },
  {
    "type": "delete-account",
    "slug": "excluir-conta-innova-lean5s",
    "id": "innova-lean5s"
  },
  {
    "type": "delete-account",
    "slug": "excluir-conta-instituto-inova",
    "id": "instituto-inova"
  },
  {
    "type": "delete-account",
    "slug": "excluir-conta-app-sp-rs",
    "id": "app-sp-rs"
  },
  {
    "type": "city",
    "slug": "criacao-de-sistema-ou-app-em-assis-chateaubriand",
    "citySlug": "assis-chateaubriand",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "criacao-de-sistema-ou-app-em-cascavel",
    "citySlug": "cascavel",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "criacao-de-sistema-ou-app-em-francisco-alves",
    "citySlug": "francisco-alves",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "criacao-de-sistema-ou-app-em-ipora",
    "citySlug": "ipora",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "criacao-de-sistema-ou-app-em-maripa",
    "citySlug": "maripa",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "criacao-de-sistema-ou-app-em-palotina",
    "citySlug": "palotina",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "criacao-de-sistema-ou-app-em-toledo",
    "citySlug": "toledo",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "criacao-de-site-em-altonia",
    "citySlug": "altonia",
    "variant": "site-criacao"
  },
  {
    "type": "city",
    "slug": "criacao-de-site-em-francisco-alves",
    "citySlug": "francisco-alves",
    "variant": "site-criacao"
  },
  {
    "type": "city",
    "slug": "criacao-de-site-em-ipora",
    "citySlug": "ipora",
    "variant": "site-criacao"
  },
  {
    "type": "city",
    "slug": "criacao-de-site-em-maripa",
    "citySlug": "maripa",
    "variant": "site-criacao"
  },
  {
    "type": "city",
    "slug": "criacao-de-site-em-palotina",
    "citySlug": "palotina",
    "variant": "site-criacao"
  },
  {
    "type": "city",
    "slug": "criacao-de-site-em-terra-roxa",
    "citySlug": "terra-roxa",
    "variant": "site-criacao"
  },
  {
    "type": "city",
    "slug": "criacao-de-site-em-toledo",
    "citySlug": "toledo",
    "variant": "site-criacao"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-sistema-ou-app-em-assis-chateaubriand",
    "citySlug": "assis-chateaubriand",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-sistema-ou-app-em-cascavel",
    "citySlug": "cascavel",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-sistema-ou-app-em-francisco-alves",
    "citySlug": "francisco-alves",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-sistema-ou-app-em-ipora",
    "citySlug": "ipora",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-sistema-ou-app-em-maripa",
    "citySlug": "maripa",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-sistema-ou-app-em-palotina",
    "citySlug": "palotina",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-sistema-ou-app-em-toledo",
    "citySlug": "toledo",
    "variant": "system"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-site-em-altonia",
    "citySlug": "altonia",
    "variant": "site-desenvolvimento"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-site-em-francisco-alves",
    "citySlug": "francisco-alves",
    "variant": "site-desenvolvimento"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-site-em-ipora",
    "citySlug": "ipora",
    "variant": "site-desenvolvimento"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-site-em-maripa",
    "citySlug": "maripa",
    "variant": "site-desenvolvimento"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-site-em-palotina",
    "citySlug": "palotina",
    "variant": "site-desenvolvimento"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-site-em-terra-roxa",
    "citySlug": "terra-roxa",
    "variant": "site-desenvolvimento"
  },
  {
    "type": "city",
    "slug": "desenvolvimento-de-site-em-toledo",
    "citySlug": "toledo",
    "variant": "site-desenvolvimento"
  }
];
